import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";

export const AlertBanner = ({ alerts }) => {
  const [dismissed, setDismissed] = useState([]);
  const visible = (alerts || []).filter((_, i) => !dismissed.includes(i));
  if (visible.length === 0) return null;

  const tone = {
    severe: "bg-red-500/15 border-red-500/40 text-red-600 dark:text-red-300",
    moderate: "bg-amber-500/15 border-amber-500/40 text-amber-700 dark:text-amber-300",
  };

  return (
    <div className="space-y-2" data-testid="weather-alert-banner">
      {(alerts || []).map((a, i) =>
        dismissed.includes(i) ? null : (
          <div
            key={i}
            data-testid={`weather-alert-${i}`}
            className={`flex items-start gap-3 rounded-2xl border px-4 py-3 fade-up ${
              tone[a.severity] || tone.moderate
            }`}
          >
            <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
            <div className="flex-1">
              <div className="font-bold text-sm">{a.event}</div>
              <div className="text-xs opacity-90">{a.description}</div>
            </div>
            <button
              data-testid={`dismiss-alert-${i}`}
              onClick={() => setDismissed((d) => [...d, i])}
              className="opacity-70 hover:opacity-100"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        )
      )}
    </div>
  );
};
